<style lang="less" scoped>
.menu-container{
    padding-bottom: 32px;

    .first-menu-title{
        display: inline-block;
        margin-left: 24px;
    }
    .second-menu-title{
        display: inline-block;
        margin-left: 36px;
        width: 214px;
        height: 20px;
        line-height: 20px;
    }
    .el-menu-div{

        .menu-right-icon{
            font-size: 12px;
            color: #ffffff;
        }

        .third-menu-title{
            margin-left: 16px;;
        }
    }
}
</style>

<template>
    <div class="menu-container" :style="menuCollapse?'width:121px':'width:294px'">
        <!-- background-color="#162E42" text-color="#8B8CA0" active-text-color="#fff" -->
        <el-menu :default-active="defaultActiveMenu" :collapse="menuCollapse" :default-openeds="defaultOpenKeys" class="el-menu-div" unique-opened @select="handleMenuSelect" text-color="#fff" active-text-color="#fff">
            
            <!-- 一级菜单 -->
            <template v-for="firstMenu in menuList">
                <el-menu-item v-if="firstMenu.meta && firstMenu.meta.type == 'noChild' && $S.checkUserMenu(firstMenu.children[0].name)" :key="firstMenu.name" :index="firstMenu.children[0].name">
                    <img :src="firstMenu.meta.icon" >
                    <span slot="title" class="first-menu-title">{{firstMenu.children[0].meta.title}}</span>
                </el-menu-item>

                <el-submenu v-if="firstMenu.meta && firstMenu.meta.type !== 'noChild' && $S.checkUserMenu(firstMenu.name)" :key="firstMenu.name" :index="firstMenu.name">
                    <template slot="title">
                         <img :src="firstMenu.meta.icon" >
                        <span class="first-menu-title">{{firstMenu.meta.title}}</span>
                    </template>

                    <!-- 二级菜单 -->
                    <template  v-for="secondMenu in firstMenu.children">
                        <el-submenu v-if="secondMenu.meta && secondMenu.meta.type == 'hasChilds' && $S.checkUserMenu(secondMenu.name)" :key="secondMenu.name" :index="secondMenu.name" >
                            <template slot="title">
                                <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
                                <span class="first-menu-title">{{secondMenu.meta.title}}</span>
                            </template>
                            <template v-for="thirdMenu in secondMenu.children">
                                 <!-- 三级菜单 -->
                                <el-menu-item  v-if="$S.checkUserMenu(thirdMenu.name)" :key="thirdMenu.name" :index="thirdMenu.name" class="second-menu-item">
                                    <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
                                    <span class="second-menu-title">{{thirdMenu.meta.title}}</span>
                                </el-menu-item>
                            </template>
                           
                        </el-submenu>
                        <el-menu-item v-if="secondMenu.meta && secondMenu.meta.type !== 'hasChilds' && $S.checkUserMenu(secondMenu.name)" :key="secondMenu.name" :index="secondMenu.name">
                            <!-- <i class="el-icon-arrow-right menu-right-icon"></i> -->
                            <span class="second-menu-title">{{secondMenu.meta.title}}</span>
                        </el-menu-item>
                    </template>

                </el-submenu>
            </template>

        </el-menu>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
            init() {},
            handleMenuSelect(key, keyPath) {
                this.$router.push({
                    name:key
                })
            },
        },
        mounted() {
            this.init();
        },
        computed:{
            // 当前选中的菜单
            defaultActiveMenu(){
                return this.$store.state.curMenuRouter || [];
            },
            // 当前展开的菜单
            defaultOpenKeys(){
                return this.$store.state.curMenuOpened || [];
            },
            menuList(){
                return this.$store.state.menuList || [];
            },
            menuCollapse(){
                return this.$store.state.menuCollapse || false;
            },
        }
    }
</script>